import React, { useEffect } from "react"
import { Row, Col } from "react-bootstrap"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"
import {
  updateUiData,
  updateValidFormData,
  getRequiredDocuments,
  getPolicyInfo,
} from "../redux/actions"
import FormTextbox from "../components/shared/formTextbox"
import FormFieldDisableAutoComplete from "../components/shared/formFieldDisableAutoComplete"
import FormDateInputTextbox from "../components/shared/formDateInputTextbox"
import * as ErrorMessage from "../common/errorMessage"
import * as Constants from "../common/constants"
import { isValid, parse } from "date-fns"
import * as CommonFunction from "../common/function"
import { missingInfoAlert } from "../services/sweetalertService"
import * as API from "../services/httpService"
import { navigate } from "gatsby"

const Index = ({ location }) => {
  const uiData = useSelector(state => state.uiData, shallowEqual)
  const claimData = useSelector(state => state.claimData, shallowEqual)
  const dispatch = useDispatch()
  const formRef = React.useRef()

  useEffect(() => {
    if (uiData.maxPageNumber === 1) {
      const GetDataPromise = API.apiPostRequest("/Claim/GetData", null, null)

      Promise.all([GetDataPromise])
        .then(values => {
          batch(() => {
            if (values[0].data) {
              dispatch(
                updateValidFormData("claimLifeDetailModel", values[0].data)
              )
            }
            dispatch(updateUiData("showLoading", false))
          })
        })
        .catch(error => {
          navigate("errorOccurred")
        })
    } else {
      // Delete all uploaded file
      if (uiData.claimUploadListModel.length > 0) {
        let deleteMultipleFileArray = []

        uiData.claimUploadListModel.forEach((UploadedItem, UploadedKey) => {
          let deleteFileInfo = {}
          deleteFileInfo.fName = UploadedItem.fileName
          deleteFileInfo.folderName = uiData.folderName
          deleteMultipleFileArray.push(deleteFileInfo)
        })

        API.apiPostRequest(
          "/Claim/ClaimDocsMultipleDelete",
          deleteMultipleFileArray,
          null
        ).then(response => {
          dispatch(updateUiData("claimUploadListModel", []))
        })
      }
    }

    CommonFunction.updateUiCurrentPageNumber(dispatch, location.href)
  }, [])

  const formikSchema = Yup.object().shape({
    policyNumber: Yup.string()
      .length(8, ErrorMessage.policyNumber)
      .required(ErrorMessage.policyNumber),
    DOB: Yup.string()
      .required(ErrorMessage.DOB)
      .test("DOB", ErrorMessage.DOB, value => {
        return isValid(
          parse(value, `d${Constants.sep}M${Constants.sep}yyyy`, new Date())
        )
      })
      .test("DOB", ErrorMessage.futureDateErrorMsg, value => {
        if (
          value &&
          isValid(
            parse(value, `d${Constants.sep}M${Constants.sep}yyyy`, new Date())
          )
        ) {
          var dateParts = value.split("/")
          var date = new Date(
            dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0]
          )
          return CommonFunction.notFutureDatime(date, "00:00")
        }
      }),
    deceasedName: Yup.string().required(ErrorMessage.deceasedName),
    NRIC: Yup.string().required(ErrorMessage.NRIC),
  })

  const generateFolderName = draftFolderPrefix => {
    let dd = new Date()
    let ss =
      "" +
      dd.getYear() +
      dd.getMonth() +
      dd.getDate() +
      dd.getHours() +
      dd.getMinutes() +
      dd.getSeconds()
    return draftFolderPrefix + ss
  }
  return (
    <Formik
      initialValues={Object.assign({}, claimData["claimLifeDetailModel"])}
      enableReinitialize={true}
      validationSchema={formikSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {
        batch(() => {
          dispatch(updateValidFormData("claimLifeDetailModel", values))
          dispatch(getRequiredDocuments(Constants.basicCoverageDetailId))
          dispatch(updateUiData("showLoading", true))
          dispatch(
            updateUiData(
              "folderName",
              generateFolderName(uiData.draftFolderPrefix)
            )
          )
          dispatch(
            getPolicyInfo({
              PolicyNumber: values.policyNumber,
              InsuredNRIC: values.NRIC,
              InsuredName: values.deceasedName,
              InsuredDOB: values.DOB,
            })
          )
        })
      }}
    >
      {({ handleSubmit, isSubmitting, isValid, values, errors }) => (
        <FormikForm onSubmit={handleSubmit}>
          <Row>
            <div className="title text-center">Death e-Claims</div>
            <div className={"containerBody"}>
              {/* <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="marginBottom16px">
                  <div className={"titleText "}>Policy Information</div>
                </div>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox singleFieldBox"
                >
                  <Field
                    textDesc="Enter your policy number"
                    maxLength={20}
                    name="policyNumber"
                    component={FormTextbox}
                  />
                </Col>
              </Col> */}
              {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
              <Field
                textDesc={"Disable Auto Complete"}
                name="disableAutoComplete"
                component={FormFieldDisableAutoComplete}
              />
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="marginBottom16px">
                  <div className={"titleText "}>Policy Information</div>
                </div>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox singleFieldBox"
                >
                  <Field
                    textDesc="Enter your policy number"
                    maxLength={20}
                    name="policyNumber"
                    component={FormTextbox}
                  />
                </Col>

                <div className="marginBottom16px marginTop30px">
                  <div className={"titleText "}>Details of Deceased</div>
                </div>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox topFieldBox mt-3"
                >
                  <Field
                    textDesc="Name of Deceased (as per NRIC)"
                    maxLength={100}
                    name="deceasedName"
                    component={FormTextbox}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox middleFieldBox"
                >
                  <Field
                    textDesc="NRIC / Passport Number"
                    maxLength={10}
                    name="NRIC"
                    component={FormTextbox}
                  />
                </Col>
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="fieldBox bottomFieldBox"
                >
                  <Field
                    textDesc="Date of Birth"
                    maxLength={10}
                    name="DOB"
                    component={FormDateInputTextbox}
                  />
                </Col>
              </Col>
            </div>
          </Row>
          <Row>
            <div className="submitFormCenterBtnDiv">
              <button
                className="btnSubmitForm fontWeightBold"
                type="submit"
                // disabled={isSubmitting}
              >
                <b>Continue</b>
              </button>
            </div>
          </Row>
          <HandleFormSubmit formRef={formRef} isSubmitting={isSubmitting} />
        </FormikForm>
      )}
    </Formik>
  )
}

const HandleFormSubmit = ({ formRef, isSubmitting }) => {
  React.useEffect(() => {
    if (isSubmitting) {
      formRef.current.validateForm().then(errors => {
        if (Object.entries(errors).length !== 0) {
          missingInfoAlert()
          formRef.current.setSubmitting(false)
        }
      })
    }
  }, [isSubmitting])
  return null
}
export default Index
